<template lang="pug">
.v-detail-specialist.detail-specialist(v-if="data" )
	.container
		.detail-specialist__card(v-if="data.info" )
			.detail-specialist__card-left
				.detail-specialist__head
					.detail-specialist__head-left
						h2.detail-specialist__head-title(v-if="data.info.title" ) {{ data.info.title }}
						.detail-specialist__head-type(v-if="data.info.type" ) {{ data.info.type }}
						.detail-specialist__note(v-if="data.info.note")  {{ data.info.note }}
					.detail-specialist__head-right
						img.detail-specialist__head-logo(v-if="data.info.logo"
							:src="data.info.logo?.src"
							:alt="data.info.logo?.alt")

				.detail-specialist__persons(v-if="data.info.persons" )
					.detail-specialist__person(v-for="(person, index) in data.info.persons" :key="index" )
						img.detail-specialist__person-image(v-if="person.image"
							:src="person.image?.src"
							:alt="person.image?.alt")
						.detail-specialist__person-column
							.detail-specialist__person-title(v-if="person.title" ) {{ person.title }}:
							.detail-specialist__person-name(v-if="person.name" ) {{ person.name }}
							.detail-specialist__person-status(v-if="person.status" ) {{ person.status }}
						.detail-specialist__person-separator
						.detail-specialist__person-column
							.detail-specialist__person-contacts(v-if="person.contacts" )
								.detail-specialist__person-contact(v-for="(contact, index) in person.contacts" :key="index")
									v-svg-icon.detail-specialist__person-contact-icon(v-if="contact.icon" :icon="contact.icon")
									template(v-if="contact.links" )
										template(v-for="(link, index) in contact.links" :key="index")
											a.detail-specialist__person-contact-link(v-if="link.href && link.text" :href="link.href") {{ link.text }}
											span.detail-specialist__person-contact-link(v-else-if="link.text") {{ link.text }}

				.detail-specialist__head-actions(v-if="data.info.buttons" )
					button.detail-page__actions-btn(v-for="(button, index) in data.info.buttons" :key="index" @click="buttonEvent(button.event, data.notification)")
						v-svg-icon.detail-page__actions-icon(v-if="button.icon" :icon="button.icon")
						.detail-page__actions-value(v-if="button.value" ) {{ button.value }}&nbsp;
						.detail-page__actions-text(v-if="button.text" ) {{ button.text }}

			.detail-specialist__card-right
				.detail-specialist__contacts(v-if="data.info.contacts" )
					h3.detail-specialist__contacts-head(v-if="data.variables.contacts" ) {{ data.variables.contacts }}
					.detail-specialist__contact(v-for="(contact, index) in data.info.contacts" :key="index" )
						.detail-specialist__contact-title(v-if="contact.title" ) {{ contact.title }}:&nbsp;
						template(v-if="contact.links" )
							template(v-for="(link, index) in contact.links" :key="index")
								a.detail-specialist__contact-link(v-if="link.href && link.text" :href="link.href") {{ addComma(contact.links, index, link.text) }}
								span.detail-specialist__contact-link(v-else-if="link.text") {{ addComma(contact.links, index, link.text) }}
		.detail-specialist__tabs.tabs-nav-detail(v-for="(filter, index) in data.filters" :key="index")
			v-field(:field="filter" v-model="filter.value" @update:model-value="filterChange(filter, $event)")
		.detail-specialist__list.flc
			transition(name="fade" mode="out-in")
				.catalog__list-message.flc(v-if="!data.items || !data.items.length && data.message")
					.catalog__list-message-title.h3.flc(v-if="data.message.title" ) {{ data.message.title }}
					.catalog__list-message-body.flc(v-if="data.message.body" ) {{ data.message.body }}
				v-product-list(v-else-if="data.type === 'products'"
					:items="data.items")
		.detail-specialist__nav
			v-page-nav(:page="data.page" :variables="data.variables" :limits="data.limits" @navigate="navigate")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';
import controller from "../scripts/controller/controller.js";

export default {
	mixins: [sourceMixin, formattingMixin],

	data() {
		return {
			data: null,
			state: {
				page: null,
				filter: null
			},
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.state.page = this.data.page;
		},

		buttonEvent(event, notification) {
			switch (event) {
				case 'share':
					navigator.clipboard.writeText(window.location.href);
					controller.addNotification(notification);
					break
			}
		},

		requestDataLoad(dataSetOptions) {
			this.dataLoad({
				url: this.data.remote,
				delay: true,
				data: {
					page: this.state.page,
					filter: this.state.filter
				}
			}, dataSetOptions);
		},

		navigate(page) {
			this.state.page.offset = page.offset;
			this.state.page.limit = page.limit;
			this.requestDataLoad({append: page.append});
		},

		filterChange(filter, value) {
			this.state.filter = {...this.state.filter, ...{[filter.name]: value}}
			this.state.page.offset = 0;
			this.requestDataLoad();
		},
	}
};
</script>